/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    fileManagementCompanyId: {},
    fileManagementAnlkl: {}
  },
  getters: {
    fileManagementCompanyId: state => state.fileManagementCompanyId,
    fileManagementAnlkl: state => state.fileManagementAnlkl
  },
  mutations: {
    fileManagementCompanyId: (state, data) => {
      state.fileManagementCompanyId = data
    },
    fileManagementAnlkl: (state, data) => {
      state.fileManagementAnlkl = data
    }
  },
  actions: {
    handleFileManagementCompanyId(fileManagementCompanyId, data) {
      fileManagementCompanyId.commit('fileManagementCompanyId', data)
    },
    handleFileManagementAnlkl(fileManagementAnlkl, data) {
      fileManagementAnlkl.commit('fileManagementAnlkl', data)
    }
  }
}
